export const initGalleryGrid = (): void => {
  const grids = document.querySelectorAll<HTMLElement>(
    "[data-masonry-gallery]",
  );
  if (grids.length === 0) return;

  // 1. Zero-Dependency Masonry Logic (CSS Grid Row Spanning)
  const resizeGridItem = (item: HTMLElement) => {
    const grid = item.parentElement;
    if (!grid) return;

    const rowHeight = parseInt(
      window.getComputedStyle(grid).getPropertyValue("grid-auto-rows"),
    );
    const rowGap = parseInt(
      window.getComputedStyle(grid).getPropertyValue("gap"),
    );
    const content = item.querySelector(
      ".gallery-grid__image",
    ) as HTMLImageElement;

    if (!content || !content.complete) return;

    // Calculate how many rows this specific image needs to span
    const rowSpan = Math.ceil(
      (content.getBoundingClientRect().height + rowGap) / (rowHeight + rowGap),
    );
    item.style.gridRowEnd = "span " + rowSpan;
  };

  const resizeAllGridItems = () => {
    document
      .querySelectorAll<HTMLElement>(".gallery-grid__item")
      .forEach(resizeGridItem);
  };

  // Wait for images to load before calculating heights
  grids.forEach((grid) => {
    const images = grid.querySelectorAll<HTMLImageElement>(
      ".gallery-grid__image",
    );
    images.forEach((img) => {
      if (img.complete) {
        resizeGridItem(img.closest(".gallery-grid__item") as HTMLElement);
      } else {
        img.addEventListener("load", () => {
          resizeGridItem(img.closest(".gallery-grid__item") as HTMLElement);
        });
      }
    });
  });

  window.addEventListener("resize", () => {
    requestAnimationFrame(resizeAllGridItems);
  });

  // 2. Magnific Popup Lightbox Initialization
  if (
    typeof (window as any).$ !== "undefined" &&
    typeof (window as any).$.fn.magnificPopup !== "undefined"
  ) {
    const $ = (window as any).$;

    $("[data-masonry-gallery]").each(function (this: HTMLElement) {
      $(this).magnificPopup({
        delegate: "a.gallery-grid__item",
        type: "image",
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1],
        },
        image: {
          titleSrc: function (item: any) {
            return item.el.attr("title") || "";
          },
        },
        mainClass: "mfp-with-zoom",
        zoom: {
          enabled: true,
          duration: 300,
          easing: "ease-in-out",
        },
      });
    });
  }

  console.log("[Gallery Grid] Masonry & Lightbox initialized.");
};
